import React, {Component} from 'react'
import {ButtonGroup, Col, ControlLabel, FormControl, FormGroup} from 'react-bootstrap'

export default class RadioField extends Component {

	render() {
		const {
			feedbackIcon,
			input,
			label,
			title,
			sizes,
			size,
			meta: {error, warning, touched},
			options,
			disabled,
			onChangeHook
		} = this.props;

		let message;
		const validationState = touched ? (error && "error") || (warning && "warning") || null : null;

		if (touched && (error || warning)) {
			message = <span className="help-block">{error || warning}</span>;
		}
		const inputValue = input.value;

		const radios = options.map(({label, value}, i) => {
			const checked = inputValue === value;
			return <label key={i} style={{flex: "auto"}} className={"btn " + (checked ? "btn-info" : "btn-default")
				+ (size ? " btn-" + size : "")
				+ (disabled ? " disabled" : "")
				+ (validationState ? " " + validationState : "")}>
				{label}
				<input type="checkbox" disabled={disabled} {...input} checked={checked}
					onFocus={() => {
					}}
					onBlur={() => {
					}}
					onClick={() => {
					}}
					onChange={() => {
						if (onChangeHook) {
							onChangeHook(value)
						}
						input.onChange(value)
					}}/>
			</label>

		});

		return (
			<FormGroup controlId={input.name} validationState={validationState} title={title}>
				{label ? <Col sm={sizes && sizes[0] ? sizes[0] : 4} componentClass={ControlLabel}>{label}</Col> : null}
				<Col sm={label ? (sizes && sizes[1] ? sizes[1] : 8) : 12}>
					<ButtonGroup data-toggle="buttons" style={options.length <= 2 ? null : {display: "flex"}}>
						{radios}
					</ButtonGroup>
					{feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
					{message}
				</Col>
			</FormGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/form/RadioField.js